// Zentrale, backend-getriebene Verifizierungs-Helfer (Voyalyo Web).
// FULL_VERIFIED wird NICHT im Client neu berechnet – es wird direkt aus /auth/me übernommen.
// Der Client leitet lediglich die passende UX (Badge/Modal/Texte) aus den Backendwerten ab.

// Bestehende, einzige Cross-Verifizierungsroute (Stripe-Identity: Alter + Identität zusammen).
export const VERIFICATION_ROUTE = "/altersverifikation";

// Maschinenlesbarer 403-Code, den Travel-Matching für gesperrte aktive Kontaktfunktionen liefert.
export const FULL_VERIFICATION_REQUIRED = "FULL_VERIFICATION_REQUIRED";

// Direkte Übernahme des Backend-Flags – KEINE Client-seitige (age && identity)-Neuberechnung.
export const isFullVerified = (u) => Boolean(u?.full_verified);

// Normalisiert das vom Backend gelieferte missing_verification (Array oder Objekt)
// tolerant zu { age, identity }-Booleans. Rät keine Feldnamen, matcht auf age/alter bzw. ident.
export function normalizeMissing(missing) {
  let arr = [];
  if (Array.isArray(missing)) arr = missing.map((m) => String(m).toLowerCase());
  else if (missing && typeof missing === "object") arr = Object.keys(missing).filter((k) => missing[k]).map((k) => k.toLowerCase());
  const joined = arr.join(",");
  return { age: /age|alter/.test(joined), identity: /ident/.test(joined) };
}

// missing_verification aus dem /auth/me-User (falls vorhanden).
export const getUserMissing = (u) => normalizeMissing(u?.missing_verification);

// Erkennt AUSSCHLIESSLICH den FULL_VERIFICATION_REQUIRED-403 (andere 403 bleiben unberührt).
export function isFullVerificationError(err) {
  if (err?.response?.status !== 403) return false;
  const d = err?.response?.data;
  const code =
    (d?.detail && typeof d.detail === "object" && d.detail.code) ||
    (typeof d?.code === "string" && d.code) ||
    (typeof d?.detail === "string" && d.detail) || null;
  return code === FULL_VERIFICATION_REQUIRED;
}

// Extrahiert die fehlenden Verifizierungen aus der 403-Fehlerantwort.
export function getErrorMissing(err) {
  const d = err?.response?.data || {};
  const m =
    (d.detail && typeof d.detail === "object" && (d.detail.missing_verification || d.detail.missing)) ||
    d.missing_verification || d.missing || null;
  return normalizeMissing(m);
}

// Baut Titel/Text/Button-Beschriftung für das Gate-Modal aus den fehlenden Verifizierungen.
export function verificationCopy(missing) {
  const onlyIdentity = missing.identity && !missing.age;
  const onlyAge = missing.age && !missing.identity;
  if (onlyIdentity)
    return { title: "Identität verifizieren", text: "Bitte verifiziere noch deine Identität, bevor du diese Funktion nutzen kannst.", button: "Identität verifizieren" };
  if (onlyAge)
    return { title: "Alter verifizieren", text: "Bitte verifiziere noch dein Alter, bevor du diese Funktion nutzen kannst.", button: "Alter verifizieren" };
  // Standard: beide fehlen (oder unbekannt) -> beide nennen.
  return { title: "Verifizierung erforderlich", text: "Für diese Funktion müssen dein Alter und deine Identität verifiziert sein.", button: "Jetzt verifizieren" };
}

// Leitet den Badge-Zustand für die Startseite aus den Backendwerten ab.
// guest | full | processing | requires_input | required
export function badgeState(user) {
  if (!user) return "guest";
  if (isFullVerified(user)) return "full";
  const s = String(user.age_verification_status || user.verification_status || "").toLowerCase();
  if (s === "processing" || s === "discrepancy_review" || s === "pending") return "processing";
  if (s === "requires_input") return "requires_input";
  return "required";
}
